function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_28327_7697)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.32 18.0117H18.07C16.69 18.0117 15.57 16.8917 15.57 15.5117C15.57 14.1317 16.69 13.0117 18.07 13.0117H22.32C23.25 13.0117 24 12.2617 24 11.3317V8.51172C24 7.13172 25.12 6.01172 26.5 6.01172C27.88 6.01172 29 7.13172 29 8.51172V11.3317C29 15.0117 26 18.0117 22.32 18.0117Z",
  fill: "url(#paint0_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.32 18.0117H18.07C16.69 18.0117 15.57 16.8917 15.57 15.5117C15.57 14.1317 16.69 13.0117 18.07 13.0117H22.32C23.25 13.0117 24 12.2617 24 11.3317V8.51172C24 7.13172 25.12 6.01172 26.5 6.01172C27.88 6.01172 29 7.13172 29 8.51172V11.3317C29 15.0117 26 18.0117 22.32 18.0117Z",
  fill: "url(#paint1_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.32 18.0117H18.07C16.69 18.0117 15.57 16.8917 15.57 15.5117C15.57 14.1317 16.69 13.0117 18.07 13.0117H22.32C23.25 13.0117 24 12.2617 24 11.3317V8.51172C24 7.13172 25.12 6.01172 26.5 6.01172C27.88 6.01172 29 7.13172 29 8.51172V11.3317C29 15.0117 26 18.0117 22.32 18.0117Z",
  fill: "url(#paint2_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.32 18.0117H18.07C16.69 18.0117 15.57 16.8917 15.57 15.5117C15.57 14.1317 16.69 13.0117 18.07 13.0117H22.32C23.25 13.0117 24 12.2617 24 11.3317V8.51172C24 7.13172 25.12 6.01172 26.5 6.01172C27.88 6.01172 29 7.13172 29 8.51172V11.3317C29 15.0117 26 18.0117 22.32 18.0117Z",
  fill: "url(#paint3_radial_28327_7697)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.6562 8.14282C26.6562 7.64232 27.062 7.23657 27.5625 7.23657V7.23657C28.063 7.23657 28.4688 7.64231 28.4688 8.14282V11.4491C28.4688 12.4501 27.6573 13.2616 26.6562 13.2616V13.2616V8.14282Z",
  fill: "url(#paint4_linear_28327_7697)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.125 14.9195H21.0138L21.0256 15.0301L21.1183 15.899L21.1278 15.9884H21.2177H22.4898C25.0315 15.9884 27.1 13.9199 27.1 11.3783V9.61467C27.1 9.29332 26.8395 9.03281 26.5181 9.03281C26.1968 9.03281 25.9363 9.29332 25.9363 9.61467V11.3783C25.9363 13.2794 24.2982 14.9195 22.3971 14.9195H21.125Z",
  stroke: "url(#paint5_radial_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.125 14.9195H21.0138L21.0256 15.0301L21.1183 15.899L21.1278 15.9884H21.2177H22.4898C25.0315 15.9884 27.1 13.9199 27.1 11.3783V9.61467C27.1 9.29332 26.8395 9.03281 26.5181 9.03281C26.1968 9.03281 25.9363 9.29332 25.9363 9.61467V11.3783C25.9363 13.2794 24.2982 14.9195 22.3971 14.9195H21.125Z",
  stroke: "url(#paint6_radial_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.125 14.9195H21.0138L21.0256 15.0301L21.1183 15.899L21.1278 15.9884H21.2177H22.4898C25.0315 15.9884 27.1 13.9199 27.1 11.3783V9.61467C27.1 9.29332 26.8395 9.03281 26.5181 9.03281C26.1968 9.03281 25.9363 9.29332 25.9363 9.61467V11.3783C25.9363 13.2794 24.2982 14.9195 22.3971 14.9195H21.125Z",
  stroke: "url(#paint7_radial_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.125 14.9195H21.0138L21.0256 15.0301L21.1183 15.899L21.1278 15.9884H21.2177H22.4898C25.0315 15.9884 27.1 13.9199 27.1 11.3783V9.61467C27.1 9.29332 26.8395 9.03281 26.5181 9.03281C26.1968 9.03281 25.9363 9.29332 25.9363 9.61467V11.3783C25.9363 13.2794 24.2982 14.9195 22.3971 14.9195H21.125Z",
  stroke: "url(#paint8_radial_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.125 14.9195H21.0138L21.0256 15.0301L21.1183 15.899L21.1278 15.9884H21.2177H22.4898C25.0315 15.9884 27.1 13.9199 27.1 11.3783V9.61467C27.1 9.29332 26.8395 9.03281 26.5181 9.03281C26.1968 9.03281 25.9363 9.29332 25.9363 9.61467V11.3783C25.9363 13.2794 24.2982 14.9195 22.3971 14.9195H21.125Z",
  stroke: "url(#paint9_radial_28327_7697)",
  strokeWidth: 0.2
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 9.00171C26.2239 9.00171 26 9.22557 26 9.50171V11.3317C26 13.3617 24.35 15.0117 22.32 15.0117H21V16.0117H22.32C24.9 16.0117 27 13.9117 27 11.3317V9.50171C27 9.22557 26.7761 9.00171 26.5 9.00171V9.00171Z",
  fill: "url(#paint10_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 9.00171C26.2239 9.00171 26 9.22557 26 9.50171V11.3317C26 13.3617 24.35 15.0117 22.32 15.0117H21V16.0117H22.32C24.9 16.0117 27 13.9117 27 11.3317V9.50171C27 9.22557 26.7761 9.00171 26.5 9.00171V9.00171Z",
  fill: "url(#paint11_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 9.00171C26.2239 9.00171 26 9.22557 26 9.50171V11.3317C26 13.3617 24.35 15.0117 22.32 15.0117H21V16.0117H22.32C24.9 16.0117 27 13.9117 27 11.3317V9.50171C27 9.22557 26.7761 9.00171 26.5 9.00171V9.00171Z",
  fill: "url(#paint12_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.6875 15.543H22.25C24.5972 15.543 26.5 13.6402 26.5 11.293V9.88672",
  stroke: "url(#paint13_radial_28327_7697)",
  strokeWidth: 0.25
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0099 2C13.2499 2 11.0099 4.24 11.0099 7V20H9.68995C8.75995 20 8.00995 19.25 8.00995 18.32V11.55C8.00995 10.15 6.85995 8.97 5.45995 9C4.09995 9.03 3.00995 10.14 3.00995 11.5V18.32C3.00995 22.01 5.99995 25 9.68995 25H11.0099V29.06C11.0099 29.58 11.4299 30 11.9499 30H20.0699C20.5899 30 21.0099 29.58 21.0099 29.06V7C21.0099 4.24 18.7699 2 16.0099 2Z",
  fill: "url(#paint14_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0099 2C13.2499 2 11.0099 4.24 11.0099 7V20H9.68995C8.75995 20 8.00995 19.25 8.00995 18.32V11.55C8.00995 10.15 6.85995 8.97 5.45995 9C4.09995 9.03 3.00995 10.14 3.00995 11.5V18.32C3.00995 22.01 5.99995 25 9.68995 25H11.0099V29.06C11.0099 29.58 11.4299 30 11.9499 30H20.0699C20.5899 30 21.0099 29.58 21.0099 29.06V7C21.0099 4.24 18.7699 2 16.0099 2Z",
  fill: "url(#paint15_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0099 2C13.2499 2 11.0099 4.24 11.0099 7V20H9.68995C8.75995 20 8.00995 19.25 8.00995 18.32V11.55C8.00995 10.15 6.85995 8.97 5.45995 9C4.09995 9.03 3.00995 10.14 3.00995 11.5V18.32C3.00995 22.01 5.99995 25 9.68995 25H11.0099V29.06C11.0099 29.58 11.4299 30 11.9499 30H20.0699C20.5899 30 21.0099 29.58 21.0099 29.06V7C21.0099 4.24 18.7699 2 16.0099 2Z",
  fill: "url(#paint16_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0099 2C13.2499 2 11.0099 4.24 11.0099 7V20H9.68995C8.75995 20 8.00995 19.25 8.00995 18.32V11.55C8.00995 10.15 6.85995 8.97 5.45995 9C4.09995 9.03 3.00995 10.14 3.00995 11.5V18.32C3.00995 22.01 5.99995 25 9.68995 25H11.0099V29.06C11.0099 29.58 11.4299 30 11.9499 30H20.0699C20.5899 30 21.0099 29.58 21.0099 29.06V7C21.0099 4.24 18.7699 2 16.0099 2Z",
  fill: "url(#paint17_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0099 2C13.2499 2 11.0099 4.24 11.0099 7V20H9.68995C8.75995 20 8.00995 19.25 8.00995 18.32V11.55C8.00995 10.15 6.85995 8.97 5.45995 9C4.09995 9.03 3.00995 10.14 3.00995 11.5V18.32C3.00995 22.01 5.99995 25 9.68995 25H11.0099V29.06C11.0099 29.58 11.4299 30 11.9499 30H20.0699C20.5899 30 21.0099 29.58 21.0099 29.06V7C21.0099 4.24 18.7699 2 16.0099 2Z",
  fill: "url(#paint18_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0099 2C13.2499 2 11.0099 4.24 11.0099 7V20H9.68995C8.75995 20 8.00995 19.25 8.00995 18.32V11.55C8.00995 10.15 6.85995 8.97 5.45995 9C4.09995 9.03 3.00995 10.14 3.00995 11.5V18.32C3.00995 22.01 5.99995 25 9.68995 25H11.0099V29.06C11.0099 29.58 11.4299 30 11.9499 30H20.0699C20.5899 30 21.0099 29.58 21.0099 29.06V7C21.0099 4.24 18.7699 2 16.0099 2Z",
  fill: "url(#paint19_radial_28327_7697)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_28327_7697)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 12.5938,
  y: 6.01172,
  width: 1.90625,
  height: 23.3281,
  fill: "#5DB65A"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_f_28327_7697)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 17.6901,
  y: 6.45801,
  width: 1.61359,
  height: 22.8818,
  rx: 0.806794,
  fill: "#7BD377"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.2658,
  cy: 6.00167,
  rx: 1.65918,
  ry: 2.14753,
  transform: "rotate(36.3733 14.2658 6.00167)",
  fill: "#5DB65A"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_f_28327_7697)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.6157,
  cy: 6.33985,
  r: 2.66187,
  fill: "url(#paint20_radial_28327_7697)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 6.86157C18.2239 6.86157 18 7.08543 18 7.36157V29.2928C18 29.569 18.2239 29.7928 18.5 29.7928V29.7928C18.7761 29.7928 19 29.569 19 29.2928V7.36157C19 7.08543 18.7761 6.86157 18.5 6.86157V6.86157Z",
  fill: "url(#paint21_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3906 7.51489V29.5508",
  stroke: "url(#paint22_linear_28327_7697)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9 23.1116V29.2928C12.9 29.6242 13.1686 29.8928 13.5 29.8928C13.8314 29.8928 14.1 29.6242 14.1 29.2928V7.36157C14.1 7.0302 13.8314 6.76157 13.5 6.76157C13.1686 6.76157 12.9 7.0302 12.9 7.36157V21.9116H9.67999C7.70525 21.9116 6.1 20.3063 6.1 18.3316V11.5616C6.1 11.2264 5.83478 10.9116 5.5 10.9116H5.48999V10.9115L5.48629 10.9116C5.16466 10.9236 4.9 11.1857 4.9 11.5116V18.3316C4.9 20.9668 7.04475 23.1116 9.67999 23.1116H12.9Z",
  stroke: "url(#paint23_linear_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9 23.1116V29.2928C12.9 29.6242 13.1686 29.8928 13.5 29.8928C13.8314 29.8928 14.1 29.6242 14.1 29.2928V7.36157C14.1 7.0302 13.8314 6.76157 13.5 6.76157C13.1686 6.76157 12.9 7.0302 12.9 7.36157V21.9116H9.67999C7.70525 21.9116 6.1 20.3063 6.1 18.3316V11.5616C6.1 11.2264 5.83478 10.9116 5.5 10.9116H5.48999V10.9115L5.48629 10.9116C5.16466 10.9236 4.9 11.1857 4.9 11.5116V18.3316C4.9 20.9668 7.04475 23.1116 9.67999 23.1116H12.9Z",
  stroke: "url(#paint24_radial_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9 23.1116V29.2928C12.9 29.6242 13.1686 29.8928 13.5 29.8928C13.8314 29.8928 14.1 29.6242 14.1 29.2928V7.36157C14.1 7.0302 13.8314 6.76157 13.5 6.76157C13.1686 6.76157 12.9 7.0302 12.9 7.36157V21.9116H9.67999C7.70525 21.9116 6.1 20.3063 6.1 18.3316V11.5616C6.1 11.2264 5.83478 10.9116 5.5 10.9116H5.48999V10.9115L5.48629 10.9116C5.16466 10.9236 4.9 11.1857 4.9 11.5116V18.3316C4.9 20.9668 7.04475 23.1116 9.67999 23.1116H12.9Z",
  stroke: "url(#paint25_radial_28327_7697)",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9 23.1116V29.2928C12.9 29.6242 13.1686 29.8928 13.5 29.8928C13.8314 29.8928 14.1 29.6242 14.1 29.2928V7.36157C14.1 7.0302 13.8314 6.76157 13.5 6.76157C13.1686 6.76157 12.9 7.0302 12.9 7.36157V21.9116H9.67999C7.70525 21.9116 6.1 20.3063 6.1 18.3316V11.5616C6.1 11.2264 5.83478 10.9116 5.5 10.9116H5.48999V10.9115L5.48629 10.9116C5.16466 10.9236 4.9 11.1857 4.9 11.5116V18.3316C4.9 20.9668 7.04475 23.1116 9.67999 23.1116H12.9Z",
  stroke: "url(#paint26_radial_28327_7697)",
  strokeWidth: 0.2
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_d_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6.86157C13.2239 6.86157 13 7.08543 13 7.36157V22.0116H9.67999C7.65002 22.0116 6 20.3616 6 18.3316V11.5616C6 11.2716 5.77002 11.0116 5.5 11.0116H5.48999C5.21997 11.0216 5 11.2416 5 11.5116V18.3316C5 20.9116 7.09998 23.0116 9.67999 23.0116H13V29.2928C13 29.569 13.2239 29.7928 13.5 29.7928V29.7928C13.7761 29.7928 14 29.569 14 29.2928V7.36157C14 7.08543 13.7761 6.86157 13.5 6.86157V6.86157Z",
  fill: "url(#paint27_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6.86157C13.2239 6.86157 13 7.08543 13 7.36157V22.0116H9.67999C7.65002 22.0116 6 20.3616 6 18.3316V11.5616C6 11.2716 5.77002 11.0116 5.5 11.0116H5.48999C5.21997 11.0216 5 11.2416 5 11.5116V18.3316C5 20.9116 7.09998 23.0116 9.67999 23.0116H13V29.2928C13 29.569 13.2239 29.7928 13.5 29.7928V29.7928C13.7761 29.7928 14 29.569 14 29.2928V7.36157C14 7.08543 13.7761 6.86157 13.5 6.86157V6.86157Z",
  fill: "url(#paint28_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6.86157C13.2239 6.86157 13 7.08543 13 7.36157V22.0116H9.67999C7.65002 22.0116 6 20.3616 6 18.3316V11.5616C6 11.2716 5.77002 11.0116 5.5 11.0116H5.48999C5.21997 11.0216 5 11.2416 5 11.5116V18.3316C5 20.9116 7.09998 23.0116 9.67999 23.0116H13V29.2928C13 29.569 13.2239 29.7928 13.5 29.7928V29.7928C13.7761 29.7928 14 29.569 14 29.2928V7.36157C14 7.08543 13.7761 6.86157 13.5 6.86157V6.86157Z",
  fill: "url(#paint29_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6.86157C13.2239 6.86157 13 7.08543 13 7.36157V22.0116H9.67999C7.65002 22.0116 6 20.3616 6 18.3316V11.5616C6 11.2716 5.77002 11.0116 5.5 11.0116H5.48999C5.21997 11.0216 5 11.2416 5 11.5116V18.3316C5 20.9116 7.09998 23.0116 9.67999 23.0116H13V29.2928C13 29.569 13.2239 29.7928 13.5 29.7928V29.7928C13.7761 29.7928 14 29.569 14 29.2928V7.36157C14 7.08543 13.7761 6.86157 13.5 6.86157V6.86157Z",
  fill: "url(#paint30_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6.86157C13.2239 6.86157 13 7.08543 13 7.36157V22.0116H9.67999C7.65002 22.0116 6 20.3616 6 18.3316V11.5616C6 11.2716 5.77002 11.0116 5.5 11.0116H5.48999C5.21997 11.0216 5 11.2416 5 11.5116V18.3316C5 20.9116 7.09998 23.0116 9.67999 23.0116H13V29.2928C13 29.569 13.2239 29.7928 13.5 29.7928V29.7928C13.7761 29.7928 14 29.569 14 29.2928V7.36157C14 7.08543 13.7761 6.86157 13.5 6.86157V6.86157Z",
  fill: "url(#paint31_radial_28327_7697)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3906 8.07422V29.5508",
  stroke: "url(#paint32_linear_28327_7697)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 20.5791,
  cy: 24.6095,
  rx: 0.342465,
  ry: 0.53065,
  fill: "#3CAC34"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5533,
  cy: 26.5117,
  rx: 0.261112,
  ry: 0.5,
  fill: "#488F42"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.262,
  cy: 4.29948,
  rx: 0.328719,
  ry: 0.586297,
  transform: "rotate(37.5287 12.262 4.29948)",
  fill: "#58B651"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.35775,
  cy: 10.3733,
  rx: 0.328719,
  ry: 0.586297,
  transform: "rotate(43.5594 4.35775 10.3733)",
  fill: "#58B651"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.16082,
  cy: 22.8944,
  rx: 0.27412,
  ry: 0.586297,
  transform: "rotate(138.521 5.16082 22.8944)",
  fill: "#4FA24F"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5934,
  cy: 9.51171,
  rx: 0.26593,
  ry: 0.51,
  fill: "#58B651"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.15 15.4517L27.86 16.1617C28.06 16.3617 28.06 16.6717 27.86 16.8717C27.66 17.0717 27.35 17.0717 27.15 16.8717L26.44 16.1617C26.24 15.9617 26.3 15.7313 26.5 15.5313C26.69 15.3313 26.95 15.2517 27.15 15.4517Z",
  fill: "url(#paint33_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.15 15.4517L27.86 16.1617C28.06 16.3617 28.06 16.6717 27.86 16.8717C27.66 17.0717 27.35 17.0717 27.15 16.8717L26.44 16.1617C26.24 15.9617 26.3 15.7313 26.5 15.5313C26.69 15.3313 26.95 15.2517 27.15 15.4517Z",
  fill: "url(#paint34_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.15 15.4517L27.86 16.1617C28.06 16.3617 28.06 16.6717 27.86 16.8717C27.66 17.0717 27.35 17.0717 27.15 16.8717L26.44 16.1617C26.24 15.9617 26.3 15.7313 26.5 15.5313C26.69 15.3313 26.95 15.2517 27.15 15.4517Z",
  fill: "url(#paint35_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.85 7.57171L24.14 6.86171C23.94 6.66171 23.94 6.35171 24.14 6.15171C24.34 5.95171 24.65 5.95171 24.85 6.15171L25.56 6.86171C25.76 7.06171 25.76 7.37171 25.56 7.57171C25.37 7.77171 25.05 7.77171 24.85 7.57171Z",
  fill: "url(#paint36_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.85 7.57171L24.14 6.86171C23.94 6.66171 23.94 6.35171 24.14 6.15171C24.34 5.95171 24.65 5.95171 24.85 6.15171L25.56 6.86171C25.76 7.06171 25.76 7.37171 25.56 7.57171C25.37 7.77171 25.05 7.77171 24.85 7.57171Z",
  fill: "url(#paint37_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.85 10.5717L3.15 9.86171C2.95 9.66171 2.95 9.35171 3.15 9.15171C3.35 8.95171 3.66 8.95171 3.86 9.15171L4.57 9.86171C4.77 10.0617 4.68438 10.2726 4.48438 10.4726C4.28437 10.6726 4.05 10.7717 3.85 10.5717Z",
  fill: "url(#paint38_linear_28327_7697)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.80097 14.4883L8.14997 14.1517C8.34997 13.9517 8.65997 13.9517 8.85997 14.1517C9.05997 14.3517 9.05997 14.6617 8.85997 14.8617L8.14997 15.5717C7.94997 15.7717 7.70325 15.9755 7.59389 15.5717C7.48455 15.168 7.60097 14.6883 7.80097 14.4883Z",
  fill: "url(#paint39_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.80097 14.4883L8.14997 14.1517C8.34997 13.9517 8.65997 13.9517 8.85997 14.1517C9.05997 14.3517 9.05997 14.6617 8.85997 14.8617L8.14997 15.5717C7.94997 15.7717 7.70325 15.9755 7.59389 15.5717C7.48455 15.168 7.60097 14.6883 7.80097 14.4883Z",
  fill: "url(#paint40_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.35547 23.3671L4.84999 23.8716C4.64999 24.0716 4.33999 24.0716 4.13999 23.8716C3.93999 23.6716 3.93999 23.3616 4.13999 23.1616L4.64547 22.6571C4.84547 22.4571 5.03828 22.586 5.23828 22.786C5.43828 22.976 5.55547 23.1671 5.35547 23.3671Z",
  fill: "url(#paint41_linear_28327_7697)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.418 27.0117H10.5C10.22 27.0117 10 26.7917 10 26.5117C10 26.2317 10.22 26.0117 10.5 26.0117H11.418C11.698 26.0117 11.7109 26.2317 11.7109 26.5117C11.7109 26.7917 11.698 27.0117 11.418 27.0117Z",
  fill: "url(#paint42_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7266 24.0117H21.4999C21.7799 24.0117 21.9999 24.2317 21.9999 24.5117C21.9999 24.7917 21.7799 25.0117 21.4999 25.0117H20.7266C20.4466 25.0117 20.3203 24.7917 20.3203 24.5117C20.3203 24.2317 20.4466 24.0117 20.7266 24.0117Z",
  fill: "url(#paint43_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7266 24.0117H21.4999C21.7799 24.0117 21.9999 24.2317 21.9999 24.5117C21.9999 24.7917 21.7799 25.0117 21.4999 25.0117H20.7266C20.4466 25.0117 20.3203 24.7917 20.3203 24.5117C20.3203 24.2317 20.4466 24.0117 20.7266 24.0117Z",
  fill: "url(#paint44_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.81 20.2973L18 22.1473V20.7073L19.1 19.5873C19.3 19.3873 19.61 19.3873 19.81 19.5873C20.01 19.7873 20.01 20.1073 19.81 20.2973Z",
  fill: "url(#paint45_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.81 20.2973L18 22.1473V20.7073L19.1 19.5873C19.3 19.3873 19.61 19.3873 19.81 19.5873C20.01 19.7873 20.01 20.1073 19.81 20.2973Z",
  fill: "url(#paint46_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.19 16.1618L14 18.0118V16.5718L12.9 15.4518C12.7 15.2518 12.39 15.2518 12.19 15.4518C11.99 15.6518 11.99 15.9618 12.19 16.1618Z",
  fill: "url(#paint47_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.19 16.1618L14 18.0118V16.5718L12.9 15.4518C12.7 15.2518 12.39 15.2518 12.19 15.4518C11.99 15.6518 11.99 15.9618 12.19 16.1618Z",
  fill: "url(#paint48_linear_28327_7697)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.2772 11.0117H18.1C18.0448 11.0117 18 11.0565 18 11.1117V11.9117C18 11.9669 18.0448 12.0117 18.1 12.0117H19.2772C19.5572 12.0117 19.7772 11.7917 19.7772 11.5117C19.7772 11.2317 19.5572 11.0117 19.2772 11.0117Z",
  fill: "url(#paint49_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2772 11.0117H18.1C18.0448 11.0117 18 11.0565 18 11.1117V11.9117C18 11.9669 18.0448 12.0117 18.1 12.0117H19.2772C19.5572 12.0117 19.7772 11.7917 19.7772 11.5117C19.7772 11.2317 19.5572 11.0117 19.2772 11.0117Z",
  fill: "url(#paint50_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.3477 10.0117H10.5C10.22 10.0117 10 9.79172 10 9.51172C10 9.23172 10.22 9.01172 10.5 9.01172H11.3477C11.6277 9.01172 11.6953 9.23172 11.6953 9.51172C11.6953 9.79172 11.6277 10.0117 11.3477 10.0117Z",
  fill: "url(#paint51_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3477 10.0117H10.5C10.22 10.0117 10 9.79172 10 9.51172C10 9.23172 10.22 9.01172 10.5 9.01172H11.3477C11.6277 9.01172 11.6953 9.23172 11.6953 9.51172C11.6953 9.79172 11.6277 10.0117 11.3477 10.0117Z",
  fill: "url(#paint52_radial_28327_7697)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_i_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4453 3.73438L11.85 3.16172C11.65 2.96172 11.34 2.96172 11.14 3.16172C10.94 3.36172 10.94 3.67172 11.14 3.87172L11.8099 4.54165C12.0099 4.74165 12.165 4.65988 12.4023 4.34375C12.6251 4.04698 12.5787 3.86781 12.4453 3.73438Z",
  fill: "url(#paint53_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.4453 3.73438L11.85 3.16172C11.65 2.96172 11.34 2.96172 11.14 3.16172C10.94 3.36172 10.94 3.67172 11.14 3.87172L11.8099 4.54165C12.0099 4.74165 12.165 4.65988 12.4023 4.34375C12.6251 4.04698 12.5787 3.86781 12.4453 3.73438Z",
  fill: "url(#paint54_linear_28327_7697)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.8455 15.624L27.75 16.5195",
  stroke: "url(#paint55_linear_28327_7697)",
  strokeWidth: 0.25
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter25_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.4375 7.23828L24.4592 6.27412",
  stroke: "url(#paint56_linear_28327_7697)",
  strokeWidth: 0.25
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter26_f_28327_7697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.5312,
  cy: 4.45703,
  rx: 0.375649,
  ry: 0.527559,
  transform: "rotate(-45 19.5312 4.45703)",
  fill: "#53C84C"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.44 3.86171L20.15 3.15171C20.35 2.95171 20.66 2.95171 20.86 3.15171C21.06 3.35171 21.06 3.66171 20.86 3.86171L20.15 4.57171C19.95 4.77171 19.64 4.77171 19.44 4.57171C19.24 4.38171 19.24 4.06171 19.44 3.86171Z",
  fill: "url(#paint57_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.44 3.86171L20.15 3.15171C20.35 2.95171 20.66 2.95171 20.86 3.15171C21.06 3.35171 21.06 3.66171 20.86 3.86171L20.15 4.57171C19.95 4.77171 19.64 4.77171 19.44 4.57171C19.24 4.38171 19.24 4.06171 19.44 3.86171Z",
  fill: "url(#paint58_linear_28327_7697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.44 3.86171L20.15 3.15171C20.35 2.95171 20.66 2.95171 20.86 3.15171C21.06 3.35171 21.06 3.66171 20.86 3.86171L20.15 4.57171C19.95 4.77171 19.64 4.77171 19.44 4.57171C19.24 4.38171 19.24 4.06171 19.44 3.86171Z",
  fill: "url(#paint59_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter27_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5938 15.6992L13.8594 16.9805",
  stroke: "#B4B987",
  strokeWidth: 0.25
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter28_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.34375 11.418V18.1367C5.34375 20.622 7.35847 22.6367 9.84375 22.6367H13.3125",
  stroke: "url(#paint60_linear_28327_7697)",
  strokeWidth: 0.15
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.0156 23.5742C12.5281 24.7492 11.5208 24.9622 11.0781 24.957C9 24.957 7.70833 24.0586 7.59375 23.5742H13.0156Z",
  fill: "url(#paint61_radial_28327_7697)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter29_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.84375 10.8555V18.2305C6.84375 19.8701 8.1729 21.1992 9.8125 21.1992V21.1992",
  stroke: "url(#paint62_linear_28327_7697)",
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter30_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.6133 3.35938L12.3008 4.03472",
  stroke: "#AAC28F",
  strokeWidth: 0.2,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter31_f_28327_7697)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.58594 9.33203L4.36888 10.1119",
  stroke: "#B5CB9A",
  strokeWidth: 0.2,
  strokeLinecap: "round"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_28327_7697",
  x: 15.57,
  y: 6.01172,
  width: 13.83,
  height: 12,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.607843 0 0 0 0 0.831373 0 0 0 0 0.54902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_28327_7697",
  x: 25.6562,
  y: 6.23657,
  width: 3.8125,
  height: 8.0249,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_28327_7697",
  x: 20.7025,
  y: 8.73286,
  width: 6.69749,
  height: 7.55552,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_28327_7697",
  x: 21.4375,
  y: 9.63672,
  width: 5.4375,
  height: 6.28125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_i_28327_7697",
  x: 3.00995,
  y: 2,
  width: 18.7,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.7
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.670588 0 0 0 0 0.858824 0 0 0 0 0.631373 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_28327_7697",
  x: 10.5938,
  y: 4.01172,
  width: 5.90625,
  height: 27.3281,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_f_28327_7697",
  x: 15.6901,
  y: 4.45801,
  width: 5.61359,
  height: 26.8818,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_28327_7697",
  x: 10.42,
  y: 2.01172,
  width: 7.69147,
  height: 7.97974,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_f_28327_7697",
  x: 12.9538,
  y: 1.67798,
  width: 9.32373,
  height: 9.32373,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_f_28327_7697",
  x: 18.0656,
  y: 7.26489,
  width: 0.650024,
  height: 22.5359,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_f_28327_7697",
  x: 4.59999,
  y: 6.46162,
  width: 9.80002,
  height: 23.7313,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_d_28327_7697",
  x: 1,
  y: 6.86157,
  width: 17,
  height: 30.9312,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_28327_7697"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_28327_7697",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_f_28327_7697",
  x: 13.0656,
  y: 7.82422,
  width: 0.650024,
  height: 21.9766,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_f_28327_7697",
  x: 19.9366,
  y: 23.7789,
  width: 1.28494,
  height: 1.66128,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_f_28327_7697",
  x: 10.9922,
  y: 25.7117,
  width: 1.12222,
  height: 1.6,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_f_28327_7697",
  x: 11.5198,
  y: 3.49321,
  width: 1.4844,
  height: 1.6127,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_f_28327_7697",
  x: 3.58867,
  y: 9.59185,
  width: 1.53817,
  height: 1.56313,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_f_28327_7697",
  x: 4.42144,
  y: 22.1189,
  width: 1.47878,
  height: 1.55093,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_f_28327_7697",
  x: 11.0275,
  y: 8.70171,
  width: 1.13186,
  height: 1.62002,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_i_28327_7697",
  x: 3,
  y: 9.00171,
  width: 1.78384,
  height: 1.77944,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.075
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.734379 0 0 0 0 0.776471 0 0 0 0 0.603922 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_i_28327_7697",
  x: 3.98999,
  y: 22.5569,
  width: 1.51912,
  height: 1.5146,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.05,
  dy: 0.05
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.745098 0 0 0 0 0.72549 0 0 0 0 0.576471 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_i_28327_7697",
  x: 12.04,
  y: 15.2018,
  width: 2.06002,
  height: 2.80996,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.658297 0 0 0 0 0.716667 0 0 0 0 0.495694 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_i_28327_7697",
  x: 10,
  y: 9.01172,
  width: 1.79531,
  height: 1,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.772549 0 0 0 0 0.776471 0 0 0 0 0.572549 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_i_28327_7697",
  x: 10.99,
  y: 2.91172,
  width: 1.66744,
  height: 1.73867,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.658297 0 0 0 0 0.716667 0 0 0 0 0.495694 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_f_28327_7697",
  x: 26.5076,
  y: 15.2852,
  width: 1.58038,
  height: 1.57324,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter25_f_28327_7697",
  x: 24.1215,
  y: 5.93506,
  width: 1.65375,
  height: 1.64233,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter26_f_28327_7697",
  x: 18.7732,
  y: 3.69902,
  width: 1.51595,
  height: 1.51602,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter27_f_28327_7697",
  x: 12.2548,
  y: 15.3613,
  width: 1.94348,
  height: 1.95703,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter28_f_28327_7697",
  x: 5.01874,
  y: 11.168,
  width: 8.54376,
  height: 11.7937,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter29_f_28327_7697",
  x: 5.34375,
  y: 9.35547,
  width: 5.46875,
  height: 13.3438,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter30_f_28327_7697",
  x: 11.3133,
  y: 3.05928,
  width: 1.28745,
  height: 1.27549,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter31_f_28327_7697",
  x: 3.28596,
  y: 9.03193,
  width: 1.38291,
  height: 1.37998,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_28327_7697"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_28327_7697",
  x1: 20.75,
  y1: 15.6367,
  x2: 27.3125,
  y2: 6.01172,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56BD50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6DCE67"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.8322 10.688) rotate(60.2551) scale(7.42249 8.80489)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.728372,
  stopColor: "#5C9E61",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C9E61"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.9687 15.7305) scale(2.40625 2.46875)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5ABA57"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5ABA57",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29 6.57352) rotate(139.068) scale(1.90365 4.57116)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91DB89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91DB89",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_28327_7697",
  x1: 27.5625,
  y1: 6.35532,
  x2: 27.5625,
  y2: 14.8553,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91E38B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91E38B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.1088 12.907) rotate(69.2744) scale(2.38278 8.59858)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7CCD79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7CCD79",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.7344 11.7305) rotate(10.9228) scale(0.907057 4.02443)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7CCD79"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7CCD79",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.0212 14.9548) rotate(-144.118) scale(0.873494 11.3212)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#47AE4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#47AE4A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.5818 16.2197) rotate(-94.0142) scale(0.860418 13.8297)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#47AE4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#47AE4A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.7981 11.7475) rotate(-176.775) scale(1.07081 3.10974)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#47AE4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#47AE4A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_28327_7697",
  x1: 23.375,
  y1: 16.0117,
  x2: 27,
  y2: 10.6367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B7839"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#59AA5F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_28327_7697",
  x1: 23.7344,
  y1: 16.1055,
  x2: 23.7344,
  y2: 15.8086,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#30733E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30733E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.5469 10.5273) rotate(75.2983) scale(3.26308 1.07887)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6CB26E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6CB26E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.1562 14.1836) rotate(-133.1) scale(2.33253 9.83474)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C9F65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C9F65",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_28327_7697",
  x1: 12.0099,
  y1: 30,
  x2: 12.0099,
  y2: 4.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52AF55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6CCC66"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_28327_7697",
  x1: 17.0724,
  y1: 30.5,
  x2: 17.1349,
  y2: 28.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#518761"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#518761",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.0951 21.3624) rotate(124.563) scale(1.03561 0.55318)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.473778,
  stopColor: "#278620"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#278620",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint17_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.34375 25.5742) rotate(-54.8565) scale(5.80889 13.4548)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#469747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#469747",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_28327_7697",
  x1: 0.8125,
  y1: 20.8242,
  x2: 6,
  y2: 20.8242,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#469747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#469747",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.67188 18.7461) rotate(130.649) scale(2.03881 2.33898)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BAD46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4BAD46",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.625 5.63673) rotate(143.49) scale(4.88593 3.7854)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#95E491"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#95E491",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_28327_7697",
  x1: 17.625,
  y1: 7.69907,
  x2: 17.625,
  y2: 29.6991,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#60B765"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#37754B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_28327_7697",
  x1: 18.3906,
  y1: 8.51489,
  x2: 20.1949,
  y2: 8.68058,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75C876"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#668B74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_28327_7697",
  x1: 6.11454,
  y1: 21.574,
  x2: 9.11248,
  y2: 18.9011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#79B876"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#79B876",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint24_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.75 10.9803) rotate(15.8324) scale(2.17631 3.34883)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8BD485"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8BD485",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint25_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.5156 20.9803) rotate(39.1065) scale(3.44325 3.5708)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85BB83"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85BB83",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint26_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.6875 15.9491) scale(0.875 6.90625)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85BB83"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85BB83",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_28327_7697",
  x1: 11.8762,
  y1: 14.4651,
  x2: 11.8762,
  y2: 29.7928,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46914C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2E5D3F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_28327_7697",
  x1: 14.1406,
  y1: 16.8241,
  x2: 13.8438,
  y2: 16.8241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A9B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A9B5B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint29_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.1406 17.3553) rotate(116.896) scale(1.20889 0.940527)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2B6B33"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B6B33",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint30_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.46875 11.3866) rotate(90) scale(7.28125 2.85773)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40A047"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#40A047",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint31_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.8438 6.86157) rotate(96.623) scale(4.33518 4.37293)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#489E4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#489E4F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear_28327_7697",
  x1: 13.3906,
  y1: 8.51484,
  x2: 15.1949,
  y2: 8.68054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B159"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#668B74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear_28327_7697",
  x1: 26.3167,
  y1: 15.7251,
  x2: 27.6132,
  y2: 17.0217,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#86B372"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A5A96D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint34_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.01 16.9723) rotate(-137.213) scale(0.645097 0.647904)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A79C66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A79C66",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear_28327_7697",
  x1: 26.8359,
  y1: 16.6523,
  x2: 27.1633,
  y2: 16.3085,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#93A880"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#93A880",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear_28327_7697",
  x1: 25.71,
  y1: 7.58983,
  x2: 24.3218,
  y2: 6.12711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#92BB7C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B75E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear_28327_7697",
  x1: 24.4766,
  y1: 7.37108,
  x2: 24.85,
  y2: 7.0664,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A6BA82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A6BA82",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear_28327_7697",
  x1: 3.14232,
  y1: 9.1535,
  x2: 4.55652,
  y2: 10.5677,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B7B06A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9AB883"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear_28327_7697",
  x1: 8.86706,
  y1: 14.1486,
  x2: 7.45286,
  y2: 15.5628,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ACB05E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#90B779"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint40_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.82812 14.5117) rotate(135) scale(1.19324 0.564455)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BEC284"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BEC284",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear_28327_7697",
  x1: 4.14463,
  y1: 23.8772,
  x2: 5.55883,
  y2: 22.463,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D9461"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#89A27B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint42_linear_28327_7697",
  x1: 10,
  y1: 26.3555,
  x2: 11.7109,
  y2: 26.3555,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#989258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C784"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F9D72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint43_linear_28327_7697",
  x1: 22,
  y1: 24.5117,
  x2: 20.3203,
  y2: 24.5117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BEBD70"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C784"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint44_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.8232 24.3455) rotate(180) scale(0.39993 0.388167)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2D090"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFCD8D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint45_linear_28327_7697",
  x1: 18.5156,
  y1: 21.996,
  x2: 19.96,
  y2: 19.5585,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AB584"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2AC5E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint46_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.6618 19.9314) rotate(138.366) scale(0.366325 0.357904)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFCD8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFCD8D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint47_linear_28327_7697",
  x1: 14.1406,
  y1: 17.3243,
  x2: 12.3594,
  y2: 15.4649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AB584"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2AC5E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint48_linear_28327_7697",
  x1: 12.04,
  y1: 15.3018,
  x2: 12.7656,
  y2: 16.0743,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9F9652"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9F9652",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint49_linear_28327_7697",
  x1: 18,
  y1: 11.5117,
  x2: 20,
  y2: 11.5117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9EBB83"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BEBC71"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint50_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.5921 11.3835) rotate(-180) scale(0.37026 0.2974)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFCD8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFCD8D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint51_linear_28327_7697",
  x1: 10,
  y1: 9.51172,
  x2: 12,
  y2: 9.51172,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A75A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87A972"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint52_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.7969 9.51172) rotate(-180) scale(0.949219 0.25)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97B27F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#97B27F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint53_linear_28327_7697",
  x1: 12.6699,
  y1: 4.23464,
  x2: 11.6456,
  y2: 2.82049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AB584"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2AC5E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint54_linear_28327_7697",
  x1: 10.99,
  y1: 3.01172,
  x2: 11.4051,
  y2: 3.59616,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9F9652"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9F9652",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint55_linear_28327_7697",
  x1: 27.6798,
  y1: 16.5039,
  x2: 26.7188,
  y2: 15.582,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C5C58F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5C58F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint56_linear_28327_7697",
  x1: 25.3906,
  y1: 7.19922,
  x2: 24.4592,
  y2: 6.28516,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BAD39F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C0C682",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint57_linear_28327_7697",
  x1: 20.8661,
  y1: 3.15181,
  x2: 19.4519,
  y2: 4.56601,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDBB6B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#96C47D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint58_linear_28327_7697",
  x1: 19.7422,
  y1: 3.4414,
  x2: 20.0234,
  y2: 3.72265,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B8D18C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFC786",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint59_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.8476 3.38864) rotate(154.654) scale(0.398625 0.317908)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D2D18E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D2D18E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint60_linear_28327_7697",
  x1: 5.34375,
  y1: 11.9271,
  x2: 10.0724,
  y2: 18.7242,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75C876"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#668B74"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint61_radial_28327_7697",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.5625 25.8555) rotate(-55.5915) scale(2.76505 1.14713)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#469747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#469747",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint62_linear_28327_7697",
  x1: 7.8125,
  y1: 14.2305,
  x2: 11.875,
  y2: 24.0742,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8ED989"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8ED989",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_28327_7697"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

function SvgCactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactus);
export default __webpack_public_path__ + "static/media/cactus.499ae8c0.svg";
export { ForwardRef as ReactComponent };